(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/filter.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/filter.js');
"use strict";


const _React = React,
  useCallback = _React.useCallback;
const Filter = _ref => {
  let productSetting = _ref.productSetting,
    availableSports = _ref.availableSports,
    filters = _ref.filters,
    onToggleSport = _ref.onToggleSport;
  const onChange = useCallback(event => {
    const idx = parseInt(event.currentTarget.getAttribute('data-id'), 10);
    const sport = availableSports[idx];
    if (!sport) {
      return;
    }
    onToggleSport(sport.type, event.currentTarget.checked);
  }, [availableSports, onToggleSport]);
  if (!productSetting || !productSetting.allowFiltering || availableSports.length <= 1) {
    return null;
  }
  return React.createElement("section", {
    "aria-label": "filtrera p\xE5 sport",
    className: "panel panel-default"
  }, React.createElement("div", {
    className: "panel-heading"
  }, React.createElement("h2", null, React.createElement("strong", null, "Sport"))), React.createElement("ul", {
    className: "list-group"
  }, availableSports.map((sport, index) => React.createElement("li", {
    className: "list-group-item-wrapper",
    key: sport.type
  }, React.createElement("label", {
    className: "list-group-item f-capitalize tt-product-link filter-flex-container pointer block",
    htmlFor: "filter-checkbox-sport-".concat(sport.name)
  }, React.createElement("div", {
    className: "form-toggle form-toggle-inline filter-checkbox-sport"
  }, React.createElement("input", {
    checked: Boolean(filters[sport.type]),
    className: "js-sport-checkbox form-toggle-input form-toggle-checkbox form-toggle-default",
    "data-id": index,
    id: "filter-checkbox-sport-".concat(sport.name),
    name: "checkbox[]",
    onChange: onChange,
    type: "checkbox"
  }), React.createElement("span", {
    className: "form-label form-label-align-left"
  }, React.createElement("div", {
    className: "form-label-btn"
  }))), React.createElement("span", null, sport.name))))));
};
setGlobal('svs.tt.components.Filter', Filter);

 })(window);